import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  handleListResponse,
  isEmpty,
  seo,
  ValidateExtensionImge,
} from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import ImageRender from "component/common/ImageRender";
import { addBulkImageUpload } from "reduxStore/action/visitorActions";

const UploadImage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [apiResponse, setApiResponse] = useState([]);
  const propertySelector = useSelector((state) => state.propertyData);
  const addBulkImageUploadSelector =
    useSelector((state) => state.visitor) || [];

  useEffect(() => {
    if (addBulkImageUploadSelector.create === true) {
      if (addBulkImageUploadSelector?.response?.status === 200) {
        setForm({});
        navigatpage("/visitor");
      }
    }
  }, [addBulkImageUploadSelector]);

  useEffect(() => {
    if (propertySelector.response) {
      const { response } = propertySelector;
      if (response?.status === 200) {
        setApiResponse(handleListResponse(response.data));
      } else {
        setApiResponse([]);
      }
    }
  }, [propertySelector]);

  useEffect(() => {
    dispatch(getAgentProperty());
  }, []);


  const handleChange = (e) => {
    if (e.target.files.length) {
      const validFile = ValidateExtensionImge(e.target);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: null,
        });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        ...form,
        preview: preview,
        raw: image,
      };
      setForm(nextFormState);
    }
  };

  const handleUpdate = () => {
    if (!handleValid()) {
      const formData = new FormData();
      form.property_id && formData.append("property_id", form.property_id);
      if (form.raw) {
        formData.append("document", form.raw);
      }
      dispatch(addBulkImageUpload(formData));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.property_id) {
      formError = true;
      err["property_id"] = strings.propertynameErr;
    }
    if (!form?.preview) {
      formError = true;
      err["validMedia"] = strings.propertyImgErr;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Bulk Upload",
      metaDescription: "Bulk upload",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.bulkUpload}
        url={"/visitor"}
        parentListing={strings.visitorList}
        titleactive={strings.bulkUpload}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.bulkUpload}</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.selectProperty}<span className="required-field"></span>
                      </label>
                      <select
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="property_id"
                        value={form.property_id}
                        onChange={(e) => {
                          var index = e.nativeEvent.target.selectedIndex;
                          var property_title = e.nativeEvent.target[index].text;
                          const nextFormState = {
                            ...form,
                            property_id: e.target.value,
                            property_title: property_title,
                          };
                          setForm(nextFormState);
                        }}
                      >
                        <option value="">
                          {strings.selectProp}
                        </option>
                        {apiResponse &&
                          apiResponse.map((item, index) => (
                            <option key={index} value={item.property_id}>
                              {item.property_title}
                            </option>
                          ))}
                      </select>
                      {formVaild.property_id && (
                        <span style={{ color: "red" }}>
                          {formVaild.property_id}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label htmlFor="exampleFormControlLastName">
                        {strings.image}
                        <span className="required-field"></span>
                      </label>
                      {(!isEmpty(form?.preview) ||
                        (form?.image && form?.image !== "undefined")) && (
                          <ImageRender
                            baseUrl={form?.preview ? "" : form?.base_url}
                            imageUrl={form?.preview || form?.image}
                            thumbnailUrl={form?.preview || form?.image}
                          />
                        )}
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={handleChange}
                      />
                      {formVaild.image && (
                        <span style={{ color: "red" }}>{formVaild.image}</span>
                      )}
                      {formVaild.validMedia && (
                        <span style={{ color: "red" }}>
                          {formVaild.validMedia}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-footer d-flex justify-content-end">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleUpdate()}
                      >
                        {strings.upload}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UploadImage;
